<div padding class="social-profiles-popover">
    <div *ngFor="let profile of socialProfiles">
        <a [href]="profile.url" [target]="'_' + profile.type" rel="noopener noreferrer">{{ profile.typeName }}</a>
    </div>
</div>
